import { apiCall, API_CONFIG } from './api';

export const settingsAPI = {
  getGeneralConfig: async () => {
    return apiCall(`${API_CONFIG.ENDPOINTS.GENERAL_CONFIG}/list`, { method: 'GET' });
  },

  updateTimeSlots: async (payload) => {
    return apiCall(`${API_CONFIG.ENDPOINTS.GENERAL_CONFIG}/time-slots`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  updateOrderCustomFields: async (fields) => {
    return apiCall(`${API_CONFIG.ENDPOINTS.GENERAL_CONFIG}/order-custom-fields`, {
      method: 'POST',
      body: JSON.stringify({ fields }),
    });
  },

  updateOrderStatuses: async (statuses) => {
    return apiCall(`${API_CONFIG.ENDPOINTS.GENERAL_CONFIG}/order-statuses`, {
      method: 'POST',
      body: JSON.stringify({ statuses }),
    });
  },

  updateNegativeOrderStatuses: async (statuses) => {
    return apiCall(`${API_CONFIG.ENDPOINTS.GENERAL_CONFIG}/negative-order-statuses`, {
      method: 'POST',
      body: JSON.stringify({ statuses }),
    });
  },

  updateOrderListColumns: async (columns) => {
    return apiCall(`${API_CONFIG.ENDPOINTS.GENERAL_CONFIG}/order-list-columns`, {
      method: 'POST',
      body: JSON.stringify({ columns }),
    });
  },

  updateDeliverySettings: async (payload) => {
    return apiCall(`${API_CONFIG.ENDPOINTS.GENERAL_CONFIG}/delivery-settings`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  previewDeliveryCharge: async (payload) => {
    return apiCall(`${API_CONFIG.ENDPOINTS.GENERAL_CONFIG}/delivery-charge-preview`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
};
